export enum CoverStatusTypeEnum {
    Unknown = -1,
    Closed = 0,
    Open = 1
}

export function coverStatusEnumLabel(status: CoverStatusTypeEnum): string {
    switch (status) {
        case CoverStatusTypeEnum.Closed:
            return "enum.coverStatus.closed";
        case CoverStatusTypeEnum.Open:
            return "enum.coverStatus.open";
        default:
            return "common.unknown";
    }
}